import "../css/theme.css";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "../OAS365Theme";

export const useCommonControlsStyle = () => {
  const theme = useTheme();
  const commonControlsStyle = {
    DropDownFiledStyle: dropDownStyle(theme),
    CheckboxFiledStyle: checkboxStyle(theme),
    CheckboxSelectedStyle: checkboxSelectedStyle(theme),
    DateTimePickerStyle: DatetimePickerFileds(theme),
    PrimaryButtonFillStyle: primaryButtonFillStyle(theme),
    SeeMorePrimaryButtonFillStyle: seeMorePrimaryButtonFillStyle(theme),
    DisableButtoneStyle: disableButtonFillStyle(theme),
    CancelButtonFillStyle: cancelButtonFillStyle(theme),
    TextFiledsStyle: modelContentTextFileds(theme),
    TextFiledMultiLineStyle: TextFiledMultiLineFileds(theme),
    TextFiledsDisableStyle: modelContentTextFiledsDisable(theme),
    AddObjButtonFillStyle: addObjButtonFillStyle(theme),
    SearchBoxStyle: SearchBoxFields(theme),
    ToggleStyle: toggleStyle(theme),
    LabelStyle: labelStyle(theme),
    LabelErrorMessageStyle: labelErrorMessageStyle(theme),
    LabelTechnicalErrorStyle: labelTechnicalErrorStyle(theme),
    LabelInformationStyle: labelInformationStyle(theme),
    HeadinglabelInformationStyle: headinglabelInformationStyle(theme),
    SublabelInformationStyle: sublabelInformationStyle(theme),
    LabelInformationMsgStyle: labelInformationMsgStyle(theme),
    NoDocumentlabelInformationMsgStyle:
      NoDocumentlabelInformationMsgStyle(theme),
    NoDocumentSublabelInformationMsgStyle:
      NoDocumentSublabelInformationMsgStyle(theme),
    SuccessItemStyles: successItemNameSize(theme),
    SuccessMessageStyle: successMessageStyle(theme),
    modelContentHeaderStyle: modelContentHeader(theme),
    DropDownSearchableStyle: dropDownSearchableStyle(theme),
    DropDownSearchableDisabledStyle: dropDownSearchableDisabledStyle(theme),
    SearchBoxDropdownStyle: searchBoxDropdownStyle(theme),
    NoResultsOptionStyle: noResultsOptionStyle(theme),
    DropdownCalloutProps: dropdownCalloutProps,
  };
  return commonControlsStyle;
};

const SearchBoxFields = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ".ms-SearchBox-field": {
          // color: theme.colors.fontColor,
          fontSize: theme.fontSizes.menusize,
          fontFamily: theme.fonts.regular,
        },
        ".ms-SearchBox": {
          height: "5px",
        },
        ":hover": {
          border: `1px solid ${theme.colors.themeDarkColor} !important`,
        },
      },
    },
  });
};

const modelContentTextFiledsDisable = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ".ms-TextField-fieldGroup": {
          margin: "0px",
          display: "flex",
          border: `1px solid Transparent !important`,
          outline: "none",
          //  color: theme.colors.fontColor,
          fontSize: theme.fontSizes.menusize,
          fontFamily: theme.fonts.regular,
          height: "39px",
          backgroundColor: "Transparent !important",
          pointerEvents: "none",
        },
      },
      ".ms-SearchBox": {
        height: "40px", // Set the desired height here
        padding: "10px", // Adjust the padding as needed
        margin: "0 10px", // Adjust the margins as needed
      },
      input: {
        margin: "0px",
        display: "flex",
        outline: "none",
        border: `1px solid Transparent !important`,
        // color: theme.colors.fontColor,
        fontSize: theme.fontSizes.menusize,
        fontFamily: theme.fonts.regular,
      },
    },
  });
};

const modelContentTextFileds = (theme) => {
  return mergeStyleSets({
    root: {
      backgroundColor: theme.colors.backgroundColor,
      selectors: {
        ".ms-TextField-fieldGroup": {
          margin: "0px",
          display: "flex",
          border: `1px solid #dcdcdc`,
          outline: "none",
          borderRadius: "0px",
          color: theme.colors.fontColor,
          fontSize: theme.fontSizes.menusize,
          fontFamily: theme.fonts.regular,
          height: "38px",
          backgroundColor: theme.colors.backgroundColor,
          transition: "border 0.2s ease",
          position: "relative",
        },
        ".ms-TextField-fieldGroup:hover": {
          border: `1px solid #4c8d6a`,
        },
        ".ms-TextField-fieldGroup:focus-within": {
          border: `1px solid #4c8d6a`,
        },

        ".ms-TextField-fieldGroup::after": {
          border: "none !important",
          content: "none !important",
        },
        ".ms-TextField": {
          backgroundColor: theme.colors.backgroundColor,
        },
        ".ms-TextField-placeholder": {
          color: "red !important",
        },
      },
      input: {
        margin: "0px",
        display: "flex",
        outline: "none",
        border: "none",
        color: theme.colors.fontColor,
        fontSize: theme.fontSizes.menusize,
        fontFamily: theme.fonts.regular,
        background: theme.colors.backgroundColor,
      },
    },
  });
};

const TextFiledMultiLineFileds = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ".ms-TextField-fieldGroup": {
          margin: "0px",
          display: "flex",
          border: `1px solid`,
          outline: "none",
          color: theme.colors.fontColor,
          fontSize: theme.fontSizes.menusize,
          fontFamily: theme.fonts.regular,
          transition: "border-color 0.2s ease-in-out",
          background: theme.colors.backgroundColor,
        },
        ".ms-TextField-fieldGroup:hover": {
          border: `1px solid ${theme.colors.themeDarkColor}`,
          background: theme.colors.backgroundColor,
        },
        ".ms-TextField-field": {
          background: theme.colors.backgroundColor,
          color: theme.colors.fontColor,
        },
      },
      input: {
        margin: "0px",
        display: "flex",
        outline: "none",
        fontColor: theme.colors.fontColor,
        fontSize: theme.fontSizes.menusize,
        fontFamily: theme.fonts.regular,
      },
    },
  });
};

const DatetimePickerFileds = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ".ms-TextField-fieldGroup": {
          margin: "0px",
          display: "flex",
          border: `1px solid transparent !important`,
          outline: "none",
          color: theme.colors.fontColor,
          fontSize: theme.fontSizes.menusize,
          fontFamily: theme.fonts.regular,
          height: "36px",
        },
        ".ms-TextField-fieldGroup:focus-within input::selection": {
          background: ` ${theme.colors.backgroundColor} !important`,
          // color: "black !important",
        },
      },
      "input:active": {
        // background: theme.colors.themeColor,
        // color: "black",
      },
      input: {
        border: `1px solid !important`,
        fontSize: theme.fontSizes.menusize,
        outline: "none",
        height: "36px",
        fontFamily: theme.fonts.regular,
        padding: "4px" /* Add padding to ensure consistent border positions */,
        boxSizing: "border-box" /* Make sure box-sizing is consistent */,
      },
      ":hover input": {
        border: `1px solid !important` /* Use initial to retain original border size */,
        outline: "none",
        height: "36px",
        fontFamily: theme.fonts.regular,
      },
      "input:focus": {
        border: `1px solid transparent !important`,
        outline: "none",
      },
    },
  });
};

const labelStyle = (theme) => {
  const style = {
    color: theme.colors.fontColor,
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.normal,
  };
  return style;
};

const labelTechnicalErrorStyle = (theme) => {
  const style = {
    color: theme.colors.fontColor,
    textAlign: "center",
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.normal,
  };
  return style;
};

const labelErrorMessageStyle = (theme) => {
  const style = {
    color: theme.colors.validationColor,
    textAlign: "center",
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.normal,
  };
  return style;
};

const labelInformationStyle = (theme) => {
  const style = {
    textAlign: "center",
    // color: theme.colors.subTitle,
    color: theme.colors.fontColor,
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.normal,
  };
  return style;
};

const headinglabelInformationStyle = (theme) => {
  const style = {
    textAlign: "center",
    color: theme.colors.fontColor,
    fontSize: theme.fontSizes.small || "15px",
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.bold || "bold",
    width: "max-content",
    padding: "2px",
  };
  return style;
};

const sublabelInformationStyle = (theme) => {
  const style = {
    textAlign: "center",
    color: theme.colors.fontColor,
    fontSize: theme.fontSizes.small || "12px",
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.normal,
    width: "max-content",
    padding: "0px",
  };
  return style;
};
const labelInformationMsgStyle = (theme) => {
  const style = {
    textAlign: "center",
    color: theme.colors.fontColor,
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.normal,
  };
  return style;
};

const NoDocumentlabelInformationMsgStyle = (theme) => {
  const style = {
    textAlign: "center",
    color: theme.colors.fontColor,
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.titleWeight,
  };
  return style;
};

const NoDocumentSublabelInformationMsgStyle = (theme) => {
  const style = {
    textAlign: "center",
    color: theme.colors.fontColor,
    fontSize: theme.fontSizes.menusize,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.normal,
    padding: "0px",
  };
  return style;
};
const dropDownStyle = (theme) => {
  const style = {
    dropdownItem: {
      selectors: {
        ":hover": {
          // backgroundColor: theme.colors.addovation20Green,
          border: `1px solid Transparent !important`,
          borderColor: theme.colors.themeColor,
        },
      },
    },
    dropdownItemsWrapper: {
      border: `1px solid !important`,
      borderWidth: "1px",
      borderStyle: "solid",
    },
    Dropdown: {
      selectors: {
        ":focus": {
          border: `1px solid !important`,
        },
        ":hover": {
          // backgroundColor: theme.colors.themeColor,
          borderColor: theme.colors.addovation20Green,
          color: "black",
          border: `1px solid !important`,
        },
      },
    },
    dropdownItems: {
      borderRadius: "1px",
      border: `1px solid !important`,
      //  padding: "10px", // adjust the padding value as needed
    },
    title: {
      height: "35px",
      border: "1px solid" + theme.dropDown.colors.border,
      fontSize: theme.fontSizes.menusize,
      fontFamily: theme.fonts.regular,
      selectors: {
        ":hover": {
          border: `1px solid !important`,
        },
        ":focus, :active": {
          borderColor: theme.colors.themeDarkColor,
          outline: "none",
        },
      },
    },
    dropdownOptionText: {
      fontSize: theme.fontSizes.normal,
      fontFamily: theme.fonts.regular,
    },
  };
  return style;
};

const toggleStyle = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ".ms-Label": {
          fontFamily: theme.fonts.regular,
        },
      },
      ".ms-Toggle-stateText": {
        fontFamily: theme.fonts.regular,
      },
    },
  });
};

const checkboxStyle = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ".ms-Checkbox-checkbox": {
          border: `1px solid ${theme.colors.Addovation20Grey} !important`,
        },
      },
      ".ms-Checkbox-checkbox:hover": {
        border: `1px solid ${theme.colors.Addovation20Grey} !important`,
      },
      ".ms-Checkbox-checkbox": {
        border: `1px solid ${theme.colors.Addovation20Grey} !important`,
      },
    },
  });
};

const checkboxSelectedStyle = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ".ms-Checkbox-checkbox": {
          border: `1px solid ${theme.colors.Addovation20Grey} !important`,
        },
      },
      ".ms-Checkbox-checkbox:hover": {
        border: `1px solid ${theme.colors.Addovation20Grey} !important`,
      },
    },
  });
};

const primaryButtonFillStyle = (theme) => {
  const style = {
    flex: "none",
    border: `1px solid  ${theme.colors.themeDarkColor} !important`,
    flexGrow: "0",
    alignItems: "center",
    fontWeight: 500,
    maxwidth: "67px",
    maxHeight: "34px",
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.menusize,
    lineHeight: "18px",
    fontStyle: "normal",
    order: "8",
    backgroundColor: theme.colors.themeDarkColor,
    color: theme.colors.deactiveFontColor,
    borderRadius: "80px",
    padding: "8px 16px",
  };
  return style;
};

const seeMorePrimaryButtonFillStyle = (theme) => {
  const style = {
    flex: "none",
    flexGrow: "0",
    alignItems: "center",
    fontWeight: "bold",
    height: "33px",
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.menusize,
    lineHeight: "18px",
    fontStyle: "normal",
    order: "8",
    backgroundColor: "transparent",
    color: theme.colors.addovation70Green,
    border: `1px solid ${theme.colors.addovation70Green}`,
    borderRadius: "80px",
    padding: "8px 16px",
  };
  return style;
};

const disableButtonFillStyle = (theme) => {
  const style = {
    flex: "none",
    border: `1px solid  ${theme.colors.deactiveColorLight} !important`,
    flexGrow: "0",
    alignItems: "center",
    fontWeight: 500,
    maxwidth: "67px",
    maxHeight: "34px",
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.menusize,
    lineHeight: "18px",
    fontStyle: "normal",
    order: "8",
    backgroundColor: theme.colors.deactiveColor,
    color: theme.colors.deactiveFontColor,
    borderRadius: "80px",
    padding: "8px 16px",
  };
  return style;
};

const cancelButtonFillStyle = (theme) => {
  const style = {
    flex: "none",
    backgroundColor: theme.colors.backgroundColor,
    color: theme.colors.addovation70Green,
    border: `1px solid ${theme.colors.addovation70Green}`,
    borderRadius: "80px",
    padding: "8px 16px",
    fontSize: theme.fontSizes.normal,
  };
  return style;
};

const successItemNameSize = (theme) => {
  const style = {
    root: {
      alignItems: "center",
      display: "flex",
      height: "auto",
      minHeight: 32,
      justifyContent: "start",
      overflow: "visible",
      paddingRight: "50px",
      // color: theme.colors.fontColor,
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.normal,
      fontWeight: theme.fontWeight.titleWeight,
    },
  };
  return style;
};

const successMessageStyle = (theme) => {
  const style = {
    root: {
      alignItems: "center",
      display: "flex",
      height: "auto",
      minHeight: 32,
      justifyContent: "start",
      overflow: "visible",
      paddingRight: "50px",
      // color: theme.colors.fontColor,
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.normal,
      fontWeight: theme.fontWeight.normal,
    },
  };
  return style;
};

const modelContentHeader = (theme) => {
  return mergeStyleSets({
    root: {
      selectors: {
        ['[class*="content"].custom-large-header']: {
          borderTopColor: "rgb(241, 69, 16)",
        },
      },
    },
  });
};

const addObjButtonFillStyle = (theme) => {
  return mergeStyleSets({
    root: {
      color: theme.colors.themeDarkColor,
      backgroundColor: theme.colors.backgroundColor,
      border: "none",
      marginTop: "-5px",
      marginLeft: "-20px",
      margin: "0",
      padding: "0",
      outline: "unset",
      selectors: {
        ".ms-Button ms-Button--primary:hover": {
          backgroundColor: `${theme.colors.backgroundColor} !important`,
        },
        ".ms-Button ms-Button--default:hover": {
          backgroundColor: theme.colors.backgroundColor,
        },
        ".ms-Button:hover": {
          border: theme.colors.backgroundColor,
          backgroundColor: theme.colors.backgroundColor,
        },
        "&.ms-Button--default:hover": {
          backgroundColor: theme.colors.backgroundColor,
        },
      },
    },
  });
};

const dropDownSearchableStyle = (theme) => {
  return mergeStyleSets({
    root: {
      width: "100%",
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.menusize,
    },
    dropdown: {
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.menusize,
      height: "38px",
      selectors: {
        "&:hover .ms-Dropdown-title": {
          color: theme.colors.fontColor,
          borderColor: "#4c8d6a",
        },
        "&:hover .ms-Dropdown-titleIsPlaceHolder": {
          color: theme.colors.fontColor,
        },
        "&:focus .ms-Dropdown-title": {
          color: theme.colors.fontColor,
          borderColor: "#4c8d6a",
        },
        "&:focus-within .ms-Dropdown-title": {
          color: theme.colors.fontColor,
          borderColor: "#4c8d6a",
        },
        "& .ms-Dropdown-title:hover": {
          color: theme.colors.fontColor,
          borderColor: "#4c8d6a",
        },
        "& .ms-Dropdown-title:focus": {
          color: theme.colors.fontColor,
          borderColor: "#4c8d6a",
        },
        "& .ms-Dropdown-caretDown:focus": {
          color: theme.colors.fontColor,
        },
        "& .ms-Dropdown-caretDown:hover": {
          color: theme.colors.fontColor,
        },
        "&:hover .ms-Dropdown-caretDown": {
          color: theme.colors.fontColor,
        },
        "&:focus .ms-Dropdown-caretDown": {
          color: theme.colors.fontColor,
        },
        "&:focus-within .ms-Dropdown-caretDown": {
          color: theme.colors.fontColor,
        },
      },
    },
    title: {
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.menusize,
      height: "38px",
      lineHeight: "38px",
      backgroundColor: theme.colors.backgroundColor,
      color: theme.colors.fontColor,
      border: `1px solid #dcdcdc`,
      transition: "border-color 0.2s ease, color 0.2s ease",
      overflow: "hidden",
      borderRadius: "0px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      selectors: {
        "&:hover": {
          borderColor: "#4c8d6a",
        },
      },
    },
    caretDown: {
      color: theme.colors.fontColor,
      lineHeight: "38px",
      transition: "color 0.2s ease",
      selectors: {
        "&:hover .ms-Dropdown-caretDown": {
          color: theme.colors.fontColor,
        },
        "& .ms-Dropdown-caretDown:hover": {
          color: theme.colors.fontColor,
        },
      },
    },
    dropdownOptionText: {
      fontSize: theme.fontSizes.menusize,
      fontFamily: theme.fonts.regular,
      color: theme.colors.fontColor,
    },
    dropdownItemsWrapper: {
      backgroundColor: theme.colors.backgroundColor,
      scrollbarColor: theme.colors.backgroundColor,
      paddingTop: "10px",
      overflowY: "auto",
    },
    dropdownItem: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      color: theme.colors.fontColor,
      selectors: {
        "&:hover": {
          backgroundColor: theme.colors.themeDarkColor + "20",
          color: theme.colors.fontColor,
        },
        "&:focus": {
          backgroundColor: theme.colors.themeDarkColor + "40",
          color: theme.colors.fontColor,
        },
        "&:active:hover": {
          backgroundColor: theme.colors.dropDownSelectColor,
          color: theme.colors.fontColor,
        },
      },
    },
    dropdownItemSelected: {
      backgroundColor: theme.colors.dropDownSelectColor,
      color: theme.colors.fontColor,
      selectors: {
        "&:hover": {
          backgroundColor: theme.colors.dropDownSelectColor,
          color: theme.colors.fontColor,
        },
        "&:active:hover": {
          backgroundColor: theme.colors.dropDownSelectColor,
          color: theme.colors.fontColor,
        },
        "&:focus": {
          backgroundColor: theme.colors.dropDownSelectColor,
          color: theme.colors.fontColor,
        },
        "&.is-selected": {
          backgroundColor: theme.colors.dropDownSelectColor,
          color: theme.colors.fontColor,
        },
      },
    },
  });
};

const dropDownSearchableDisabledStyle = (theme) => {
  return mergeStyleSets({
    root: {
      width: "100%",
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.menusize,
      selectors: {
        "&:focus .ms-Dropdown-title": {
          color: "#939393",
        },
        "&:focus-within .ms-Dropdown-title": {
          color: "#939393",
        },
        "& .ms-Dropdown-title:hover": {
          color: "#939393",
        },
        "& .ms-Dropdown-title:focus": {
          color: "#939393",
        },
        "& .ms-Dropdown.is-open .ms-Dropdown-title": {
          color: "#939393",
        },
        "& .ms-Dropdown-caretDown:focus": {
          color: "#939393",
        },
        "& .ms-Dropdown-caretDown:hover": {
          color: "#939393",
        },
        "&:hover .ms-Dropdown-caretDown": {
          color: "#939393",
        },
        "&:focus .ms-Dropdown-caretDown": {
          color: "#939393",
        },
        "&:focus-within .ms-Dropdown-caretDown": {
          color: "#939393",
        },
      },
    },
    dropdown: {
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.menusize,
      height: "38px",
    },
    title: {
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.menusize,
      height: "38px",
      lineHeight: "38px",
      backgroundColor: theme.colors.disableDropDownColor,
      color: "#939393",
      border: "none",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    caretDown: {
      color: "#939393",
      lineHeight: "38px",
    },
    dropdownItemsWrapper: {
      backgroundColor: theme.colors.backgroundColor,
      maxHeight: "300px",
      overflowY: "auto",
    },
  });
};

const searchBoxDropdownStyle = (theme) => {
  return mergeStyleSets({
    root: {
      margin: "4px 8px",
      border: `1px solid #dcdcdc`,
      borderRadius: "0px",
      fontFamily: theme.fonts.regular,
      fontSize: theme.fontSizes.menusize,
      backgroundColor: theme.colors.backgroundColor,
      color: theme.colors.fontColor,
      selectors: {
        ".ms-SearchBox-field": {
          color: theme.colors.fontColor,
          fontSize: theme.fontSizes.menusize,
          fontFamily: theme.fonts.regular,
        },
        ".ms-SearchBox": {
          height: "5px",
        },
        ":hover": {
          border: `1px solid ${theme.colors.themeDarkColor} !important`,
        },
      },
    },
    iconContainer: {
      paddingRight: "4px",
    },
  });
};

const noResultsOptionStyle = (theme) => {
  return {
    padding: "8px 16px",
    color: theme.colors.fontColor,
    opacity: 0.7,
    fontStyle: "italic",
    textAlign: "center",
    fontSize: theme.fontSizes.menusize,
    fontFamily: theme.fonts.regular,
  };
};

const dropdownCalloutProps = {
  calloutMaxHeight: 300,
  directionalHintFixed: false,
  directionalHint: 6,
  isBeakVisible: false,
  gapSpace: 0,
  doNotLayer: false,
};
